<template>
  <div class="cmp-box">
    <div class="card-box">
      <div class="top-box">
        <div class="title">银联待提现余额(元)</div>
        <div class="money">¥ {{ walletInfo.availableBalance || 0 }}</div>
        <div class="btn" @click="capitalChecking">资金对账</div>
      </div>
       <div class="bottom-box">
        <van-cell-group :border="false" title-class="title" size="large">
          <van-cell title="累计提现金额" :value="`¥${walletInfo.totalWithdrawalAmount || 0}`" />
          <van-cell title="冻结保证金" :value="`¥${walletInfo.frozenMarginAmount}`" >
            <template #title>
              <div class="cell-title">
                <span>冻结保证金</span>
                <van-button class="btn" size="mini" :disabled="walletInfo.frozenMarginAmount <= 0" @click="earnestMoneyWithdrawal">保证金提现</van-button>
              </div>
            </template>
          </van-cell>
          <van-cell title="提现银行信息" is-link  @click="lookInfo" />
        </van-cell-group> 
      </div>
    </div>
    <div class="btn-box">
      <van-button class="btn" @click="unionpayRecord">记录</van-button>
      <van-button class="btn" :disabled="walletInfo.availableBalance <= 0" @click="withdrawal">提现</van-button>
    </div>
    <div class="tips-box">
      提示: <br/>
      一、关于银联待提现金额  <br/>
      1.1“银联待提现金额”是该商家自己对应的银联商户号中，待提现金额汇总数; <br/>
      1.2 银联待提现金额为银联支付平台扣除0.4%手续费后的金额； <br/>
      1.3 银联待提现金额不包含“冻结保证金”。 <br/>
      二、关于“冻结保证金" <br/>
      2.1 为了降低客户对全友平台的投诉，所有商家均要留存500元做为客户退款保证金； <br/>
      2.2 “冻结保证金"金额来源于平时客户支付的交易款，不需要单独向平台打款； <br/>
      2.3 “冻结保证金"金额退款：若商家不使用拓客宝，方可发起退保证金申请；申请一经提交后，该商家所属的所有职员均不能再进拓客宝系统，且无法撤消退款申请，慎点！！ <br/>
      三、关于提现 <br/>
      点击右下角“提现”，即可发起提现操作，提现金到指定账户（即银联商户号绑定的法人银行卡，或公司对公账户）。 <br/>
      四、关于提现记录 <br/>
      查看历史“提现记录”，点击左下角“记录”，即可查看 。 <br/>
    </div>
    <withdrawal-pop ref="withdrawalRef" :availableBalance="walletInfo.availableBalance" @withdrawSuccess="unionPayBalance"/>
    <tips-pop :isShowTipsPop.sync="isShowTipsPop" :tipsInfo="tipsInfo" />
    <card-info-pop ref="cardInfoRef" />
  </div>
</template>

<script>
import withdrawalPop from '@/pages/unionpay-withdrawal/compoents/withdrawal-pop.vue'
import tipsPop from '@/pages/withdrawal/compoents/tips-pop.vue';
import cardInfoPop from '@/pages/unionpay-withdrawal/compoents/card-info-pop.vue';
export default {
  components: { 
    withdrawalPop,
    tipsPop,
    cardInfoPop
  },
  data() {
    return {
      walletInfo: {
        availableBalance: 0,
        totalWithdrawalAmount: 0,
        frozenMarginAmount: 0,
      },
      isShowTipsPop: false,
      tipsInfo: {},
    }
  },
  mounted() {
    this.queryCustomerPayWay()
    this.unionPayBalance();
  },
  methods: {
    withdrawal() {
      const {availableBalance } = this.walletInfo 
      this.$router.push({
        path: '/unionpay-withdrawal',
        query: { 
          balance: availableBalance
        }
      })
    },
    earnestMoneyWithdrawal() {
      this.$refs.withdrawalRef.open()
    },

    unionpayRecord() {
      this.$router.push({
        path: '/record',
        query: {
          walletId: this.walletInfo.walletId,
          walletType: 2
        },
      });
    },
    unionPayBalance() {
      this.$api.withdrawal.unionPayBalance().then((res) => {
        if (res.data) {
          this.walletInfo = res.data
        }
      });
    },
    queryCustomerPayWay() {
      this.$api.withdrawal.queryCustomerPayWay()
        .then(res => {
          this.tipsInfo = res.data
          if (res.data.payType != 'union') {
            this.isShowTipsPop = true
          }
        })
    },
    capitalChecking() {
      this.$router.push({
        path: '/capital-checking',
        query: {
          type: 2,
        },
      })
    },
    lookInfo() {
      this.$api.withdrawal.queryUnionBankInfo().then(res => {
        if (res.success) {
          this.$refs.cardInfoRef.open(res.data)
        } 
      })
    }
  }
}
</script>

<style scoped lang="stylus">
  .cmp-box {
    .card-box {
      background: #EDEDED;
      border-radius: 13px;
      .top-box {
        width: 100%;
        height: 120px;
        padding: 15px 0 0 20px;
        background: url('~@/assets/images/withdraw.png');
        background-size: 100% 100%;
        box-sizing: border-box;
        color: #fff;
        .title {
          font-size: 17px;
        }
        .money {
          font-size: 28px;
          font-weight: bold;
          line-height: 40px;
        }
        .btn {
          width: 72px;
          height: 22px;
          border-radius: 4px;
          text-align: center;
          line-height: 22px;
          color: #FF6B31;
          background: #fff;
        }
      }
      .bottom-box {
        margin-top: 10px;
        /deep/ .van-cell-group {
          background: #EDEDED;
          border-radius: 0 0 13px 13px;
        }
        /deep/ .van-cell  {
          background: #EDEDED;
          &::after {
            border-color: #D8D8D8;
          }
        }
        /deep/ .van-cell:last-child {
          border-radius: 0 0 13px 13px;
        }
        /deep/ .van-cell__title{
          color: #666666;
        }
        /deep/ .van-cell__value {
          color: #FF6B31;
        }
        .cell-title {
          display: flex;
          .btn {
            border-radius: 3px;
            border: 1px solid #FF6B31;
            color: #FF6B31;
            font-size: 12px;
            margin-left: 10px;
            background: transparent;
          }
        }
      }
    }
    .btn-box {
      display: flex;
      justify-content: center;
      margin-top: 10px;
      .btn {
        width: 90px;
        height: 34px;
        border-radius: 4px;
        color: #FF6B31;
        border: 1px solid #FF6B31;
        background: transparent;
        &:first-child {
          margin-right: 10px;
        }

      }
    }
    .tips-box {
      color: #999999;
      font-size: 13px;
      line-height: 22px;
      padding-bottom: 10px;
    }
  }
</style>
